/**
 * Home extracts for Market Intelligence and Networking.
 * Preference readiness stays in insightPreferences — these helpers only
 * choose what a ready response is allowed to show.
 */

/** Timed events drop once the start has passed. Date-only listings last through that local day. */
export function isUpcomingEvent(event, now = Date.now()) {
  const raw = event?.date || event?.startDate;
  if (raw == null || String(raw).trim() === '') return false;
  const value = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    const endOfDay = new Date(year, month - 1, day, 23, 59, 59, 999).getTime();
    return endOfDay >= now;
  }
  const start = new Date(value).getTime();
  return Number.isFinite(start) && start >= now;
}

function eventSortTime(event) {
  const raw = event?.date || event?.startDate;
  const value = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day).getTime();
  }
  const start = new Date(value).getTime();
  return Number.isFinite(start) ? start : Number.POSITIVE_INFINITY;
}

/** Soonest events that have not started. Undated rows are left out. */
export function selectUpcomingEvents(events, now = Date.now(), limit = 2) {
  if (!Array.isArray(events)) return null;
  return events
    .filter((event) => event && isUpcomingEvent(event, now))
    .slice()
    .sort((a, b) => eventSortTime(a) - eventSortTime(b))
    .slice(0, limit);
}

/**
 * Pro may show two teasers. Basic shows one master item when an edition exists.
 * An industry-only teaser still counts as a real extract.
 */
export function selectHomeTeasers(teasers, { full = false } = {}) {
  if (!Array.isArray(teasers)) return null;
  if (full) return teasers.slice(0, 2);
  const master = teasers.find((item) => item && item.kind === 'master');
  const chosen = master || teasers[0];
  return chosen ? [chosen] : [];
}

/** True only when the teaser response says a job is queued or running. */
export function isBriefingInProgress(meta, status) {
  return meta?.refreshPending === true || status === 'generating';
}
